import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Footer.css";

import FooterLogo from "../../../Assets/Logo/Logo.png";
import StoreIcon from "../../../Assets/Footer/Store.png";
import ConsumerIcon from "../../../Assets/Footer/Consumer.png";
import DeliveryIcon from "../../../Assets/Footer/Delivery_new.png";
import VendorIcon from "../../../Assets/Footer/Vendors.png";
import ProducerLogo from "../../../Assets/Home/Generation_Section/pdlogo.png";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section id="footer" className="footer">

      {/* MAIN ROW */}
      <div className="footer-content">

        {/* LEFT SIDE */}
        <div className="footer-left">

          {/* CLICKABLE LOGO (scrolls to top) */}
          <img
            src={FooterLogo}
            className="footer-logo"
            alt="Fulupo"
            onClick={() => {
              if (location.pathname !== "/") {
                navigate("/");
              }
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            style={{ cursor: "pointer" }}
          />

          <p className="footer-desc">
            AI-powered store management SaaS platform revolutionizing retail
            operations with voice AI, image recognition, and intelligent
            automation for the future of retail.
          </p>

          <p className="footer-company">
            <strong>DoubleTap Innovations and Technologies Private Limited</strong>
          </p>
        </div>

        {/* MIDDLE — PRODUCTS */}
        <div className="footer-products">
          <h3>Products</h3>

          <ul>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.doubletap.fulupostore" target="_blank" rel="noopener noreferrer">
                <img src={StoreIcon} alt="" /> Fulupo Store
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.doubletap.fulupo" target="_blank" rel="noopener noreferrer">
                <img src={ConsumerIcon} alt="" /> Fulupo Consumer
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.doubletap.fulupodelivery" target="_blank" rel="noopener noreferrer">
                <img src={DeliveryIcon} alt="" /> Fulupo Delivery
              </a>
            </li>
            <li>
              <Link to="/coming-soon">
                <img src={VendorIcon} alt="" /> Fulupo Vendors
              </Link>
            </li>
          </ul>

          <div className="producer-link-img">
            <img src={ProducerLogo} alt="Producer Logo" className="footer-producer-logo" />
          </div>
        </div>

        {/* RIGHT — CONTACT */}
        <div className="footer-contact">
          <h3>Contact</h3>
          <p>
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=fulupoaistore@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-link"
            >
              fulupoaistore@gmail.com
            </a>
          </p>
          <p>
            <a
              href="tel:+919600043880"
              className="footer-contact-link"
            >
              +91 9600043880
            </a>
          </p>
          <p>India</p>
          <a href="https://doubletapinnovations.ai" target="_blank" rel="noopener noreferrer" className="footer-website-link">doubletapinnovations.ai</a>
        </div>

        {/* LEGAL */}
        <div className="footer-legal">
          <h3>Legal</h3>
          <ul>
            <li>
              <Link to="/terms-and-conditions">Terms and conditions</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy policy</Link>
            </li>
          </ul>
        </div>

      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        © 2025 DoubleTap Innovations and Technologies Private Limited.
        All rights reserved.
      </div>

    </section>
  );
}

export default Footer;
